import React, { FC, ReactNode } from "react";
import { Spin } from "antd";
import { RiseOutlined, FallOutlined } from "@ant-design/icons";
import { statusTone } from "./statusColors";

interface StatCardProps {
  label: string;
  value: ReactNode;
  icon?: ReactNode;
  // "brand" (default) or a status name — tints ONLY the icon chip; the value
  // stays ink. This is the professional fix for rainbow KPI numbers.
  tone?: string;
  trend?: { value: number; isUp: boolean };
  onClick?: () => void;
  active?: boolean;
  loading?: boolean;
}

const BRAND_CHIP = { bg: "#e5ebfa", fg: "#2557d6" };

const StatCard: FC<StatCardProps> = ({
  label,
  value,
  icon,
  tone = "brand",
  trend,
  onClick,
  active = false,
  loading = false,
}) => {
  const chip =
    tone === "brand"
      ? BRAND_CHIP
      : { bg: statusTone(tone).bg, fg: statusTone(tone).dot };

  const className = [
    "pms-stat-card",
    onClick ? "pms-stat-card--clickable" : "",
    active ? "pms-stat-card--active" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={className}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === "Enter") onClick();
            }
          : undefined
      }
    >
      {icon && (
        <span
          className="pms-stat-chip"
          style={{ background: chip.bg, color: chip.fg }}
        >
          {icon}
        </span>
      )}
      <div style={{ minWidth: 0 }}>
        <div className="pms-eyebrow">{label}</div>
        <div className="pms-stat-value">
          {loading ? <Spin size="small" /> : value}
        </div>
        {trend && (
          <div
            className="pms-stat-trend"
            style={{ color: trend.isUp ? "#237804" : "#a8071a" }}
          >
            {trend.isUp ? <RiseOutlined /> : <FallOutlined />} {trend.value}%
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
